const visibleNameFields = new Set('firstName lastName firstname lastname ownerFirstName ownerLastName'.split(' '));
const is_visible_name = (field, value) => visibleNameFields.has(field) || field === 'ownerName' && value.contactAccess?.publicNameFields?.includes(field);
const contactArrays = new Set('phones phoneNumbers phoneList emails emailAddresses emailList'.split(' '));
const timelineFields = new Set('actions comments history histories timeline legacy_timeline'.split(' '));
const protectedContainers = new Set('actions comments history histories timeline legacy_timeline offer importedFields clientLink businessLink tags assets client_fields billing shipping contact contacts prefill accountRegistration socialLinks ideas content plan report salesAttribution salesCredits'.split(' '));
const displayFields = new Set('firstName lastName firstname lastname ownerFirstName ownerLastName username ownerUsername fullName ownerName email emails emailList emailAddresses ownerEmail phone phones phoneList phoneNumbers ownerPhone location address headquarters vatNumber taxId website facebook instagram linkedin vat locationCoordinates locations importedEmailAddresses importedPhoneNumbers normalizedEmailAddresses normalizedPhoneNumbers value sourceValue survivorValue label subtitle'.split(' '));

// Values are never guessed from an old row. Presence, including false, comes from the server.
export function read_contact_display_payload(value) {
    if (Array.isArray(value)) return value.map(read_contact_display_payload);
    if (!value || typeof value !== 'object') return value;
    const output = Object.fromEntries(Object.entries(value).map(([key, item]) => [key, timelineFields.has(key) ? item : read_contact_display_payload(item)]));
    if (value.contactAccess?.allowed === false) {
        for (const [field, present] of Object.entries(value.contactAccess.presence || {})) {
            if (timelineFields.has(field)) continue;
            if (is_visible_name(field, value)) {
                if (output[field] === undefined) output[field] = '';
                continue;
            }
            if (displayFields.has(field)) output[field] = contactArrays.has(field) ? present ? ['***'] : [] : present ? '***' : '';
        }
    }
    return output;
}

export function read_contact_patch(value) {
    if (Array.isArray(value)) return value.map(read_contact_patch);
    if (!value || typeof value !== 'object') return value;
    const output = {};
    for (const [key, item] of Object.entries(value)) {
        if (key === 'contactAccess' || item === '***' || Array.isArray(item) && item.includes('***')) continue;
        if (displayFields.has(key) && value.contactAccess?.allowed === false) continue;
        output[key] = read_contact_patch(item);
    }
    return output;
}

// An assignment mutation invalidates any older response; session changes invalidate every response.
export function create_contact_request_epoch() {
    let revision = 0;
    return {
        begin(subject, mutation = false) {
            if (mutation) revision += 1;
            return { subject: subject || '', revision };
        },
        invalidate() { revision += 1; },
        current(stamp, subject) { return stamp.subject === (subject || '') && stamp.revision === revision; }
    };
}

// Failed/revoked writes may never restore a previously captured contact-bearing card.
export function revoke_contact_display_payload(value) {
    if (Array.isArray(value)) return value.map(revoke_contact_display_payload);
    if (!value || typeof value !== 'object') return value;
    const output = {};
    const presence = { ...(value.contactAccess?.presence || {}) };
    for (const [key, item] of Object.entries(value)) {
        if (timelineFields.has(key)) {
            output[key] = item;
            delete presence[key];
        } else if (is_visible_name(key, value)) {
            output[key] = item;
            delete presence[key];
        } else if (displayFields.has(key)) {
            presence[key] = Array.isArray(item) ? item.length > 0 : item !== null && item !== undefined && item !== '';
        } else if (protectedContainers.has(key) || Object.prototype.hasOwnProperty.call(value.contactAccess?.presence || {}, key)) {
            presence[key] = Array.isArray(item) ? item.length > 0 : Boolean(item);
        } else output[key] = revoke_contact_display_payload(item);
    }
    output.contactAccess = { allowed: false, presence, ...(value.contactAccess?.publicNameFields ? { publicNameFields: value.contactAccess.publicNameFields } : {}) };
    return read_contact_display_payload(output);
}
